import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModuleRoutingModule } from './store-module-routing.module';
import { StoreSiteComponent } from './store-site/store-site.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from 'src/app/app.module';
import { HttpClient } from '@angular/common/http';
import { HomeComponent } from 'src/app/home/home.component';
import { SharedComponentsModule } from 'src/app/shared/shared-components/shared-components.module';

@NgModule({
  declarations: [StoreSiteComponent],
  imports: [
    CommonModule,
    SharedComponentsModule,
    StoreModuleRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    TranslateModule
  ],
  providers: [HomeComponent]
})
export class StoreModuleModule { }
